module.exports = __webpack_public_path__ + "static/media/plus.e8e1e7c0.svg";